import { render, staticRenderFns } from "./EmailVerificationPage.vue?vue&type=template&id=0a2b972c&"
import script from "./EmailVerificationPage.vue?vue&type=script&lang=js&"
export * from "./EmailVerificationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports